import { render, staticRenderFns } from "./DuixiangLists.vue?vue&type=template&id=62c263f0&"
import script from "./DuixiangLists.vue?vue&type=script&lang=js&"
export * from "./DuixiangLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DuixiangLists.vue"
export default component.exports